<template>
  
    <basic-container>
        <el-form label-width="100px" inline>
          <el-form-item label="项目">
            <!-- {{editFormData.projectId}} -->
            <el-input v-model="projectName" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划名称">
            <!-- {{editFormData.name}} -->
            <el-input v-model="editFormData.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划开始时间">
            <!-- {{editFormData.planBeginTime}} -->
            <el-input v-model="editFormData.planBeginTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划结束时间">
            <!-- {{editFormData.planEndTime}} -->
            <el-input v-model="editFormData.planEndTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="周期类型">
            <!-- {{editFormData.inspectCycleType}} -->
            <el-input v-model="inspectCycleTypeName" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划巡检设备">
            <!-- {{editFormData.deviceNames}} -->
            <el-input v-model="editFormData.deviceNames" disabled></el-input>
          </el-form-item>
        </el-form>
      </basic-container>
</template>

<script>
  import selectTime from "./select-time";
  import {getDeviceList, getStandardList, saveInspectPlan, updateInspectPlan, getDetail, getInspectCycleTypeDicData} from "@/api/crmedical/device/deviceinspectplan";
  import {getProjectList} from "@/api/crmedical/group/group";
  
export default {
  props: ['editFormData'],
  components: {
    'select-time': selectTime,
  },
    data(){
        return{
          inspectCycleTypeName:'',
          projectName:'',
          selectedList:[],
          standardList:[],
          selectTimeFlag:false,
          tempProjectId:'',
          inspectLineList:[],
          inspectForm:{},
          selectedTime:[],
          quantumTime:[],
          dialogInspectLineCreateBoxVisible:false,
          // editFormData:{
          //     inspectCycleType:1,
          //     detailDate:[],
          // },
          inspectCycleType:1,
          deviceList:[],
          projectList:[],
        }
    },
    created(){
      console.log(this.editFormData);
      this.editFormData.dateRange = [this.editFormData.planBeginTime,this.editFormData.planEndTime];
      if(this.editFormData.timeQuantum){
        let timeQuantumList = this.editFormData.timeQuantum.split(',');
        timeQuantumList.forEach((el,i)=>{
          let timeRange = el.split('+')[0];
          let days = el.split('+')[1];
          let start = timeRange.split('~')[0];
          let end = timeRange.split('~')[1];
          this.quantumTime.push({
            start:start,
            end:end,
            days:days
          });
        });
      }
      if(this.editFormData.detailDate){
        this.editFormData.detailDate = this.editFormData.detailDate.split(',');
        // detailDateList.forEach((ele,index)=>{
          
        // });
      }
      getDetail({id:this.editFormData.id}).then((res)=>{
        console.log(res);
        this.editFormData.devices = res.data.devices;
        this.inspectLineList = res.data.devices;
      });
        getProjectList().then((res)=>{
            console.log(res);
            this.projectList = res.data;
            res.data.forEach((ele,index)=>{
              if(ele.id === this.editFormData.projectId){
                this.projectName = ele.name;
                console.log('6666');
              }
            })
            // this.editFormData.
            // this.addGroupForm.projectId = this.projectList[0].id;
        });
        getInspectCycleTypeDicData().then((res)=>{
          console.log(res);
          res.data.forEach((ele,index)=>{
              if(ele.dictKey == this.editFormData.inspectCycleType){
                this.inspectCycleTypeName = ele.dictValue;
                console.log('99999');
              }
            })
          // this.inspectCycleTypeList = res.data;
          // res.data.forEach((ele,index)=>{
          //   if(ele.dic){

          //   }
          // });
        })
        this.tempProjectId = this.editFormData.projectId
        getDeviceList({projectId:this.tempProjectId}).then((res)=>{
          console.log(res);
          this.deviceList = res.data;
        });
      
                this.editFormData = Object.assign({}, this.editFormData,{'dateRange':[this.editFormData.planBeginTime,this.editFormData.planEndTime]})
    },
    mounted(){
        // setTimeout(()=>{

            this.selectTimeFlag = true;
        // },1000)
    },
    methods:{
        cancelInspectAddFrom(){
            this.$emit('closeEditForm');
        },
        submitInspectAddFrom(){
            if(this.editFormData.dateRange){
                this.editFormData.planBeginTime = this.editFormData.dateRange[0]
                this.editFormData.planEndTime = this.editFormData.dateRange[1]
            }
            
            if(this.editFormData.detailDate){
                this.editFormData.detailDate = this.editFormData.detailDate.join(',');
            }
            // console.log(this.selectedTime);
            console.log(this.editFormData);
            console.log(this.inspectLineList);
            console.log(this.inspectForm);
            if(this.inspectLineList){
              this.editFormData.devices = [];
              this.inspectLineList.forEach((e,i)=>{
                this.editFormData.devices.push({
                  standardIds:e.standardIds instanceof Array?e.standardIds.join(','):e.standardIds,
                  deviceId:e.deviceId
                })
              });
            }
            updateInspectPlan(this.editFormData).then((res)=>{
              console.log(res);
              this.$emit('closeEditForm');
            });
        },
        handleProjectIdChange(val){
            this.tempProjectId = val;
        },
      handleDeviceChange(val){
        
        // getDeviceList().then((res)=>{
        //   console.log(res);
        //   this.deviceList = res.data;
        // });
        console.log('8888');
        this.deviceList.forEach((ele,index)=>{
          if(ele.id === val){
            this.inspectForm.deviceName = ele.name;
          }
        });
        getStandardList({deviceId:val}).then((res)=>{
            // console.log(res);
            this.standardList = res.data
        });
      },
      handleStandardChange(val){
        console.log('8888');
        this.inspectForm.standardNames = [];
        console.log(this.inspectForm.standardIds,this.standardList);
        this.standardList.forEach((ele,index)=>{
          this.inspectForm.standardIds.forEach((el,i)=>{
            if(ele.id === el){
              this.inspectForm.standardNames.push(ele.name);
            }
          });
        });
        console.log(this.inspectForm.standardNames);
        // getStandardList({deviceId:val}).then((res)=>{
        //     // console.log(res);
        //     this.standardList = res.data
        // });
      },
      addInspectLine(){
          getDeviceList({projectId:this.tempProjectId}).then((res)=>{
          console.log(res);
          this.deviceList = res.data;
        });
        this.dialogInspectLineCreateBoxVisible = true;
      },
      saveInspectLineHandler(){
        this.inspectLineList.push({
            deviceName:this.inspectForm.deviceName,
            deviceId:this.inspectForm.deviceId,
            standardIds:this.inspectForm.standardIds,
            standardNames:this.inspectForm.standardNames?this.inspectForm.standardNames.join(','):'',
            });
        this.dialogInspectLineCreateBoxVisible = false;
      },
      handleCycleTypeChange(val){
        this.editFormData.detailDate = [];
        this.editFormData.inspectCycleType = val;
      },
        // 获得时间选择器传来的值
        getTime(time) {
        // this.inspectplanAddForm.timeQuantum = time;
            console.log(time);
            if(time){
                let timeList = [];
                time.forEach((ele,index)=>{
                    timeList.push(ele.time);
                })
                this.editFormData.timeQuantum = timeList.join(',');
            }
        },
    }
}
</script>

<style>

</style>